import { Formik } from "formik";
import { Grid } from "@mui/material";
import queryString from "query-string";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import FormThree from "./FormThree";
import { useAlert, useAxios } from "../../../hooks";
import {
  ButtonFooter,
  ComponentHeader,
  PageHeader,
  Paper,
} from "../../../components";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import ViewAgreement from "../../company components/agreement components/ViewAgreement";
import {
  objectFromFormData,
  objectFromResponseData,
  validationSchema,
} from "../../company components/company details components/companyDetailsObject";
import FormFour from "./FormFour";
import FormThreeUpload from "../../company components/company details components/FormThree";
import EditButtons from "../../../components/EditButtons";

export default function FormDisplay({
  editState,
  setFormData,
  formData,
  noDetails,
  setEditState,
  platformID,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const [viewAgreement, setViewAgreement] = useState({
    data: {},
    state: false,
  });

  const brandID =
    useSelector((state) => state.memberDetails?.activeBrand.ID) ||
    queryString.parse(window.location.search).brandID ||
    sessionStorage.getItem("brandID");

  const agencyID =
    useSelector((state) => state.memberDetails?.agencyID) ||
    queryString.parse(window.location.search).agencyID ||
    sessionStorage.getItem("agencyID");

  return (
    <Fragment>
      <Grid size={12}>
        <PageHeader
          pageName={"Company Details"}
          pageHeader={formData.companyName}
          buttons={[
            parseInt(formData.is_agency_verified) === 0 && (
              <EditButtons editState={editState} setEditState={setEditState} />
            ),
          ]}
        />
      </Grid>

      {noDetails && (
        <Paper>
          <Grid size={12} alignSelf={"center"}>
            <ActiveTextEighteen color={colors.error}>
              Agency hasn't registered it's company yet.
            </ActiveTextEighteen>
          </Grid>
        </Paper>
      )}

      <Grid size={12}>
        <Formik
          enableReinitialize
          initialValues={formData}
          validateOnMount
          validationSchema={validationSchema}
          onSubmit={(formData, { setSubmitting }) => {
            axios({
              url: "/user/companyProfile",
              method: "POST",
              disableRedirect: true,
              data: objectFromFormData(formData, brandID, agencyID),
            })
              .then((response) => {
                if (response.status) {
                  setFormData(objectFromResponseData(response.data));
                  dispatch(
                    alert({
                      type: "success",
                      message: response.message.displayMessage,
                    })
                  );
                  setEditState(false);
                } else {
                  dispatch(
                    alert({
                      type: "error",
                      message: response.message,
                    })
                  );
                }
                setSubmitting(false);
              })
              .catch((err) => {
                console.error(err);
              });
          }}
        >
          {(formikProps) => (
            <Fragment>
              <Paper gridSpacing={4}>
                <Grid size={12}>
                  <ComponentHeader title={"Company Details"} />
                </Grid>

                <FormOne
                  brandID={brandID}
                  agencyID={agencyID}
                  platformID={platformID}
                  editState={editState}
                  formikProps={formikProps}
                />

                <FormTwo editState={editState} formikProps={formikProps} />

                {editState ? (
                  <FormThreeUpload
                    editState={editState}
                    formikProps={formikProps}
                  />
                ) : (
                  <FormThree editState={editState} formikProps={formikProps} />
                )}
              </Paper>

              {editState && (
                <Grid size={12}>
                  <ButtonFooter
                    disabled={!formikProps.values.gstVerified}
                    editState={editState}
                    setEditState={setEditState}
                    ID={formikProps.values.ID}
                    formikProps={formikProps}
                  />
                </Grid>
              )}

              {formikProps?.values?.ID && (
                <Paper>
                  <FormFour
                    brandID={brandID}
                    agencyID={agencyID}
                    platformID={platformID}
                    editState={editState}
                    formikProps={formikProps}
                  />
                </Paper>
              )}
            </Fragment>
          )}
        </Formik>

        <ViewAgreement
          viewAgreement={viewAgreement}
          setViewAgreement={setViewAgreement}
        />
      </Grid>
    </Fragment>
  );
}
